import { openExplanationModal } from "./ModalControl";
import { dismissWarning } from "../helpers";

export function defaultTooltipCreator(td, defaultMessage, valFormatted) {
    let span = document.createElement("span")
    span.className = "genericTooltip tooltiptext"
    td.innerHTML = valFormatted;
    td.className = " defaultVal"
    span.className += " defaultTooltip"

    span.innerHTML += defaultMessage;

    td.className = td.className + " tooltipCustom"
    var rightAligndiv = document.createElement("div");
    rightAligndiv.className = "rightAligned";
    rightAligndiv.appendChild(span);
    td.appendChild(rightAligndiv);
    return td
}

export function errorTooltipCreator(td, props, value, warningErrorIndex, warningErrorIndexes, listOfErrorWarning, currentRowID) {
    var span = document.createElement("span")
    span.className = "genericTooltip tooltiptext"
    // Unknown function
    if (typeof value === "string" && value.length === 0 && props.tableName !== "Expenses") {
        span.style.marginLeft = `${td.offsetWidth}px`;
    }
    var finalErrorId = 2;
    var errorExplanation = ''

    warningErrorIndexes.forEach(warningPair => {
        warningErrorIndex = warningPair[1];
        var qName = warningPair[0]

        var warningError = listOfErrorWarning[warningErrorIndex];

        var warningSpan = document.createElement("span")

        warningSpan.innerHTML = warningError.errorMessage

        var clickTextOpt1 = document.createElement("a");
        var clickTextOpt2 = document.createElement("a");
        var orText = document.createElement("span");
        clickTextOpt1.addEventListener('click', function () {
            openExplanationModal(warningError.rowID, warningError.errorId, value, warningError);
        }, false);
        clickTextOpt2.addEventListener('click', function () {
            dismissWarning(qName, currentRowID, warningError.errorId, "dismiss");
        }, false);

        clickTextOpt2.innerHTML = `click to dismiss`
        clickTextOpt2.className = "click-to-dismiss"
        orText.innerHTML = " or "

        if (warningError.errorTypeID == 2 || warningError.errorTypeID == 1) {
            errorExplanation = warningError.errorExplanation;
            if (warningError.errorExplanation == null || warningError.errorExplanation.length == 0) {
                clickTextOpt1.innerHTML = `<br/>Add Explanation`
                clickTextOpt1.className = "click-to-dismiss"

                warningSpan.appendChild(clickTextOpt1)
                warningSpan.appendChild(orText)
                warningSpan.appendChild(clickTextOpt2)
            }
            else {
                td.className = td.className + " dismissed"
                clickTextOpt1.innerHTML = warningError.errorExplanation
                clickTextOpt1.className = "error-explanation-text"

                warningSpan.innerHTML += '<br/>Your comment: '
                warningSpan.appendChild(clickTextOpt1)
            }
        }

        if (finalErrorId > warningError.errorTypeID)
            finalErrorId = warningError.errorTypeID

        span.appendChild(warningSpan);
    })
    if (finalErrorId == 2 || finalErrorId == 1) {
        if (errorExplanation == null || errorExplanation.length == 0) {
            td.className = td.className + " validationWarning"

            // Unsure of why you cant set style.background to important
            // Unsure why the second line uses style.backgroundColor instead of style.background
            td.style.background = "#f4f1cf";
            td.style.setProperty("background-color", td.style.backgroundColor, "important");
        }
        else {
            td.style.background = "#d3eed2";
            td.style.setProperty("background-color", td.style.backgroundColor, "important");
        }
    }
    else if (finalErrorId == 0) {
        td.className = td.className + " validationError"
        td.style.background = "#f4d4cf";
        td.style.setProperty("background-color", td.style.backgroundColor, "important");
    }

    td.className = td.className + " tooltipCustom"

    var rightAligndiv = document.createElement("div");
    rightAligndiv.className = "rightAligned";
    rightAligndiv.appendChild(span);
    td.appendChild(rightAligndiv);

}